import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import { createCharger } from '../../services/chargerService';

const CreateChargerModal = ({ isOpen, onClose, onChargerCreated }) => {
  const [formData, setFormData] = useState({
    device_id: '',
    product_id: '',
    category: '',
    uuid: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setFeedback({ type: '', message: '' });
    try {
      await createCharger(formData);
      setFeedback({ type: 'success', message: 'Cargador creado correctamente.' });
      setTimeout(() => {
        onChargerCreated();
        onClose();
      }, 1500);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al crear el cargador.';
      setFeedback({ type: 'error', message: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Crear Nuevo Cargador</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="device_id"
          label="Device ID"
          type="text"
          fullWidth
          variant="standard"
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="product_id"
          label="Product ID"
          type="text"
          fullWidth
          variant="standard"
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="category"
          label="Categoría"
          type="text"
          fullWidth
          variant="standard"
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="uuid"
          label="UUID"
          type="text"
          fullWidth
          variant="standard"
          onChange={handleChange}
        />
        {feedback.message && (
          <Alert severity={feedback.type} sx={{ mt: 2 }}>
            {feedback.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? <CircularProgress size={24} /> : 'Crear'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateChargerModal;
